const Backbone = require('backbone');
const SocialBarView = require('app/views/store/common/social/social_bar');
const CategoryShowView = Backbone.View.extend({
	initialize: function() {
		this.childViews.social = new SocialBarView();
	},

	events: {
		'click #filter-products': 'toggleFilters'
	},

	el: $('#page-content'),

	toggleFilters: function() {
		// All of content on category/show is encapsulated with this object. Delegate accordingly.
		const $filters = $('#filters');

		if (!$filters.hasClass('hidden')) {
			$filters.hide().addClass('hidden');
		} else {
			$filters.show().removeClass('hidden');
		}
	}
});

module.exports = CategoryShowView;
